// Assure qu'aucun mesh ne reste en mémoire entre deux salles.

export class RoomCleanup {
    static clear(manager) {
        // Portails
        manager.portals.forEach(p => {
            if (p.metadata?.coreMesh) p.metadata.coreMesh.dispose();
            if (!p.isDisposed()) p.dispose();
        });

        // Trigger de sortie
        if (manager.exitTrigger && !manager.exitTrigger.isDisposed()) {
            manager.exitTrigger.dispose();
        }

        // Bonus — dispose aussi les meshes satellites (groundRing, orbitRing)
        // Sans ça, les anneaux orbitaux et les halos au sol restaient entre les salles.
        manager.bonusCrates.forEach(crate => {
            if (!crate || crate.isDisposed()) return;
            const meta = crate.metadata;
            if (meta?.groundRing && !meta.groundRing.isDisposed()) meta.groundRing.dispose();
            if (meta?.orbitRing  && !meta.orbitRing.isDisposed())  meta.orbitRing.dispose();
            crate.dispose();
        });

        // Nœuds d'environnement (plateformes, décorations, portails visuels)
        manager.envNodes.forEach(n => {
            if (n && !n.isDisposed()) n.dispose();
        });

        // Reset des références
        manager.portals      = [];
        manager.bonusCrates  = [];
        manager.envNodes     = [];
        manager.exitTrigger  = null;
    }
}